"use strict";

define("forum/account/edit/usernameOverrid", [
    "forum/account/header",
    "forum/account/edit/username",
], function (header, AccountEditUsername) {
    AccountEditUsername.init = function () {
        console.log("forum/account/edit/usernameOverrid init");
        header.init();

        $("#submitBtn").on("click", function updateUsername() {
            var userData = {
                uid: $("#inputUID").val(),
                username: $("#inputNewUsername").val(),
            };

            if (!userData.username) {
                return;
            }

            var btn = $(this);
            btn.addClass("disabled").find("i").removeClass("hide");
            socket.emit("user.changeNickname", userData, function (err, data) {
                btn.removeClass("disabled").find("i").addClass("hide");
                if (err) {
                    return app.alertError(err.message);
                }

                var userslug = utils.slugify(userData.username);
                if (
                    userData.username &&
                    userslug &&
                    parseInt(userData.uid, 10) === parseInt(app.user.uid, 10)
                ) {
                    $('[component="header/profilelink"]').attr(
                        "href",
                        config.relative_path + "/user/" + userslug
                    );
                    $('[component="header/profilelink/edit"]').attr(
                        "href",
                        config.relative_path + "/user/" + userslug + "/edit"
                    );
                    $('[component="header/profilelink/settings"]').attr(
                        "href",
                        config.relative_path + "/user/" + userslug + "/settings"
                    );
                    $('[component="header/username"]').text(userData.username);
                    $('[component="header/usericon"]')
                        .css("background-color", data["icon:bgColor"])
                        .text(data["icon:text"]);
                }

                ajaxify.go("user/" + userslug + "/edit");
            });

            return false;
        });
    };

    return AccountEditUsername;
});
